import React from 'react'

const JunkRemovalIntroduction = () => {
    return (
        <>
            <section className="about bg2 ">
                <div className="container">
                    <div className="section-title">
                        <br />
                        <h2 className="animated fadeInDown">Introduction</h2>
                        <div className="bar" />
                        <div className="row">
                            <div className="col-lg-12">
                                <div className=" cd-intro-content bouncy shadow p-4 animated swing">
                                    <div className="row">
                                        <div className="col-md-12 allpara" style={{textAlign:'left'}}>
                                            <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                                                Junk Removal
                                            </h3>
                                            <p>
                                                This module provides functionality for customers. Customers
                                                can browse the providers based on service. Based on the
                                                location &amp; service, customers will get the providers.
                                                Customers will have facilities to contact the providers by
                                                using mobiles, redirect to a website, email or can see the
                                                location of the providers. Customers can request for the quote
                                                to the Provider and Provider will contact them for the
                                                service.
                                            </p>
                                            <p>Residential Cleaning</p>
                                            <p>Moving</p>
                                            <p>Renovation</p>
                                            <p>Storage</p>
                                            <p>Disaster</p>
                                            <p>Commercial Junk Removal</p>
                                            <p>Account Request Form</p>
                                            <p>Book An Appointment</p>
                                        </div>
                                        {/* <div className="col-md-4">
                                            <div className="video-responsive mt-5">
                                                <video width="100%" height={200} controls="">
                                                    <source
                                                        src="assets/img/all-banner/Alobah-Final.mp4"
                                                        type="video/mp4"
                                                    />
                                                </video>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default JunkRemovalIntroduction